import Title from "../Title";
import Subtitle from "../Subtitle";
import Text from "../Text";
import Image from "../Image";
import Button from "../Button";

import "./index.css";

const UseCaseCard = ({
  title,
  subtitle,
  image,
  imageStyle = {},
  button,
  text,
  type,
}: UseCaseCardProps) => {
  const handleOnClick = () => {
    if (button.onClick) button.onClick();
  };

  return (
    <div className="use-case-card-container" onClick={handleOnClick}>
      <div style={{ position: "relative", zIndex: 2 }}>
        <Subtitle type={type} text={subtitle} />
        <Title style={styles.title} type={type} text={title} />
        <Text type={type} text={text} />
      </div>
      <div style={{ position: "relative", zIndex: 2 }}>
        <Button {...button} />
      </div>
      {image && (
        <Image style={{ ...styles.image, ...imageStyle }} imagePath={image} />
      )}
    </div>
  );
};

const styles = {
  title: {
    color: "black",
    fontFamily: "Tungsten",
    fontSize: "50px",
    fontWeight: "350",
    lineHeight: "95%",
    marginBottom: "15px",
  },
  image: {
    position: "absolute" as "absolute",
    right: 0,
    bottom: "-4px",
    zIndex: 0,
  },
};

export default UseCaseCard;
